export const reqStatusTypes = {
	idle: 'IDLE',
	pending: 'PENDING',
	succeeded: 'SUCCEEDED',
	failed: 'FAILED',
};

export const imagePlaceholder = "http://www.ultimatesource.toys/wp-content/uploads/2013/11/dummy-image-square-1.jpg"
